import { render } from "./ProgressCounter.vue?vue&type=template&id=2032f993&scoped=true"
import script from "./ProgressCounter.vue?vue&type=script&lang=js"
export * from "./ProgressCounter.vue?vue&type=script&lang=js"

import "./ProgressCounter.vue?vue&type=style&index=0&id=2032f993&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2032f993"]])

export default __exports__